export default __webpack_public_path__ + "a47afc9cb17073aadfa47cf88d021e17.jpg";